import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  PersonFormKeys,
  SignupService,
} from 'src/app/services/signup/signup.service';

@Component({
  selector: 'app-signup-unified-person-complementary',
  templateUrl: './signup-unified-person-complementary.component.html',
  styleUrls: ['./signup-unified-person-complementary.component.scss'],
})
export class SignupUnifiedPersonComplementaryComponent implements OnInit {
  tabs: Tab[] = [
    {
      label: 'Geral',
      error: !this.signupService.personFormValid.complementaryGeneral,
      errorKey: 'complementaryGeneral',
    },
    {
      label: 'Endereço',
      error: !this.signupService.personFormValid.complementaryAddress,
      errorKey: 'complementaryAddress',
    },
    {
      label: 'Dados bancários',
      error: !this.signupService.personFormValid.complementaryBank,
      errorKey: 'complementaryBank',
    },
    {
      label: 'Profissional',
      error: !this.signupService.personFormValid.complementaryProfessional,
      errorKey: 'complementaryProfessional',
    },
    {
      label: 'Fundos de interesse',
      error: !this.signupService.personFormValid.complementaryBond,
      errorKey: 'complementaryBond',
    },
    {
      label: 'Informações de risco',
      error: !this.signupService.personFormValid.complementaryRisk,
      errorKey: 'complementaryRisk',
    },
    {
      label: 'Representantes',
      error: !this.signupService.personFormValid.complementaryRepresentatives,
      errorKey: 'complementaryRepresentatives',
    },
  ];

  tabIndex = 0;
  role: string | null = null;

  title = '';

  stepSlug: PersonSteps = 'complementaryGeneral';

  constructor(public signupService: SignupService, private router: Router) {}

  ngOnInit(): void {
    let urlParts = this.router.url.split('/pf')[0].split('/');
    let range = urlParts.length;
    this.role = urlParts[range - 1];

    // Remover tab de risco se for cedente ou prestador
    const isAssignor = this.router.url.includes('assignor');
    const isProvider = this.router.url.includes('provider');
    if (isAssignor || isProvider) {
      const riskTabIndex = this.tabs.findIndex(
        (tab) => tab.errorKey === 'complementaryRisk'
      );
      if (riskTabIndex !== -1) {
        this.tabs.splice(riskTabIndex, 1);
      }
    }

    this.stepSlug = this.signupService.getPersonStep();

    // Se for cedente ou prestador e tentar acessar etapa de risco, redirecionar para representantes
    if ((isAssignor || isProvider) && this.stepSlug === 'complementaryRisk') {
      this.stepSlug = 'complementaryRepresentatives';
      this.signupService.setPersonStep('complementaryRepresentatives');
      this.signupService.changePersonStepEvent.emit('representatives');
    }

    this.setTitle();

    this.signupService.personStatusChangeEvent.subscribe(() => {
      this.tabs.forEach((tab) => {
        const key: PersonFormKeys = tab.errorKey ?? '';

        tab.error = !(this.signupService.personFormValid[key] ?? false);
      });
    });

    this.signupService.changePersonStepEvent.subscribe((step) => {
      const aux = `complementary${
        step.charAt(0).toUpperCase() + step.slice(1)
      }` as PersonSteps;

      // Se for cedente ou prestador e tentar acessar etapa de risco, redirecionar para representantes
      const isProvider = this.router.url.includes('provider');
      if ((isAssignor || isProvider) && aux === 'complementaryRisk') {
        this.stepSlug = 'complementaryRepresentatives';
        this.signupService.setPersonStep('complementaryRepresentatives');
        this.signupService.changePersonStepEvent.emit('representatives');
      } else {
        this.stepSlug = aux;
      }
      this.setTitle();
    });
  }

  setTitle() {
    switch (this.stepSlug) {
      case 'complementaryGeneral':
        this.title = 'Geral';
        break;

      case 'complementaryAddress':
        this.title = 'Endereço residencial';
        break;

      case 'complementaryBank':
        this.title = 'Dados bancários';
        break;

      case 'complementaryProfessional':
        this.title = 'Profissional';
        break;

      case 'complementaryBond':
        this.title = 'Fundos de interesse';
        break;

      case 'complementaryRisk':
        this.title = 'Informações de risco';
        break;

      case 'complementaryRepresentatives':
        this.title = 'Representantes';
        break;

      default:
        break;
    }
  }
}
